const initialState = {
  loading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'LOADING':
      const { loading } = action;
      return {
        ...state,
        loading,
      };
    default:
      return state;
  }
};

export const setLoading = (
  loading,
) => ({
  type: 'LOADING',
  loading,
});
